import React from 'react';
import { Grid, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6, 0),

  '& .HISContentGrid': {
    [theme.breakpoints.down('lg')]: {
      order: 2,
    },
  },
  '& .HISImgGrid': {
    height: theme.spacing(52),
    [theme.breakpoints.down('lg')]: {
      height: theme.spacing(18),
      order: 1,
      marginBottom: theme.spacing(4),
    },
  },
  '& .HISBenfitsSkeleton': {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.secondary.light}`,
  },
}));

const HeroImgSectionSkeleton = () => (
  <StyledBox>
    <Grid container display="flex" spacing={3}>
      <Grid item xs={12} lg={6} className="HISContentGrid">
        <Skeleton
          variant="rectangular"
          width="90%"
          height={60}
          style={{ marginBottom: 8 }}
        />
        <Skeleton
          variant="rectangular"
          width="80%"
          height={20}
          style={{ marginBottom: 80 }}
        />
        <Box className="HISBenfitsSkeleton">
          <Box mb={4} display="flex" justifyContent="space-between">
            <Skeleton
              variant="rectangular"
              width="200px"
              height={40}
              style={{ marginRight: 8 }}
            />
            <Skeleton variant="rectangular" width="200px" height={20} />
          </Box>
          <Skeleton
            variant="rectangular"
            width="70%"
            height={20}
            style={{ marginBottom: 5 }}
          />
          <Skeleton
            variant="rectangular"
            width="70%"
            height={20}
            style={{ marginBottom: 5 }}
          />
          <Skeleton
            variant="rectangular"
            width="70%"
            height={20}
            style={{ marginBottom: 5 }}
          />
          <Skeleton
            variant="rectangular"
            width="70%"
            height={20}
            style={{ marginBottom: 5 }}
          />
        </Box>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={20}
          style={{ marginTop: 8 }}
        />
      </Grid>
      <Grid item xs={12} lg={6} className="HISImgGrid">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Grid>
    </Grid>
  </StyledBox>
);
export { HeroImgSectionSkeleton };
